// extracted by mini-css-extract-plugin
export default {"search":"Search_search__86+BB","box":"Search_box__YGuZA","focusedSearch":"Search_focusedSearch__mFEpa"};